import { Table } from "@components/Table"
import { GraphApproval, GraphApprovalStatus } from "@custom-types/graphs"
import { getApprovalsTableColumns } from "@features/administration/approvals/helpers"
import { Info } from "@mui/icons-material"
import { IconButton, Tooltip } from "@mui/material"
import { useGetApprovalsQuery } from "@store/services/approvalsService"
import { useNavigate } from "react-router"

const ApprovalsTable = () => {
  const navigate = useNavigate()

  const { data: approvalsResponse } = useGetApprovalsQuery({ status: GraphApprovalStatus.Waiting })
  const approvals = approvalsResponse?.items ?? []

  const columns = getApprovalsTableColumns()

  const handleViewResultsClick = (approval: GraphApproval) => {
    navigate(`/Administration/Publish-Approvals/${approval.key}`)
  }

  return (
    <Table
      data={approvals}
      columns={columns}
      sessionStorageName="graph-approvals-table"
      isExportable={false}
      isExportableSelection={false}
      isExportableRows={false}
      rowCount={approvalsResponse?.total}
      enableRowActions
      renderRowActions={({ row }) => {
        return (
          <Tooltip title="View results">
            <IconButton onClick={() => handleViewResultsClick(row.original)}>
              <Info />
            </IconButton>
          </Tooltip>
        )
      }}
    />
  )
}

export default ApprovalsTable
